/**
 * Guardian-student relationship type presets.
 * Keep in sync with gradde-ai/backend/app/core/relationship_types.py
 */

export const DEFAULT_RELATIONSHIP_TYPE = 'parent';

export interface RelationshipTypePreset {
    value: string;
    label: string;
}

export const RELATIONSHIP_TYPE_PRESETS: RelationshipTypePreset[] = [
    { value: 'mother', label: 'Mother' },
    { value: 'father', label: 'Father' },
    { value: 'parent', label: 'Parent' },
    { value: 'guardian', label: 'Guardian' },
    { value: 'stepmother', label: 'Stepmother' },
    { value: 'stepfather', label: 'Stepfather' },
    { value: 'grandparent', label: 'Grandparent' },
    { value: 'aunt', label: 'Aunt' },
    { value: 'uncle', label: 'Uncle' },
    { value: 'sibling', label: 'Sibling' },
    { value: 'other', label: 'Other' },
];

const PRESET_LABELS = new Map(
    RELATIONSHIP_TYPE_PRESETS.map((preset) => [preset.value, preset.label]),
);

export function formatRelationshipLabel(value?: string | null): string | null {
    if (!value?.trim()) {
        return null;
    }
    const normalized = value.trim();
    return PRESET_LABELS.get(normalized) ?? normalized;
}

export function isPresetRelationshipType(value: string): boolean {
    return PRESET_LABELS.has(value.trim());
}

export function resolveRelationshipTypeValue(
    presetValue: string,
    customValue?: string,
): string {
    if (presetValue === 'other') {
        return customValue?.trim() || DEFAULT_RELATIONSHIP_TYPE;
    }
    return presetValue.trim() || DEFAULT_RELATIONSHIP_TYPE;
}

export function splitRelationshipTypeValue(value?: string | null): {
    presetValue: string;
    customValue: string;
} {
    if (!value?.trim()) {
        return { presetValue: DEFAULT_RELATIONSHIP_TYPE, customValue: '' };
    }
    const normalized = value.trim();
    if (PRESET_LABELS.has(normalized)) {
        return { presetValue: normalized, customValue: '' };
    }
    return { presetValue: 'other', customValue: normalized };
}
